<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 標題" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-button type="danger" v-auth="'del'+auth_val" @click="deleteAll" size="mini">批量刪除</el-button> -->
				</template>

				<!-- 高級搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="標題" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索標題"></el-input>
						</el-form-item>

						<el-form-item label="編號" class="mb-0">
							<el-input size="small" v-model="from.email_no" placeholder="搜索編號"></el-input>
						</el-form-item>
						
						<el-form-item label="發送人" class="mb-0">
							<el-input size="small" v-model="from.in_name" placeholder="發送人"></el-input>
						</el-form-item>
						
						<el-form-item label="類型" class="mb-0">
							<el-select v-model="from.type" size="small" placeholder="請選擇查看類型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="普通郵箱" :value="1"></el-option>
								<el-option label="題目反饋" :value="2"></el-option>
							</el-select>
						</el-form-item>

						<el-form-item label="已讀狀態" class="mb-0">
								<el-select v-model="from.check_status" size="small" >
									<el-option label="全部" :value="-1"></el-option>
									<el-option label="已讀" :value="1"></el-option>
									<el-option label="未讀" :value="2"></el-option>
								</el-select>
							</el-form-item>

						<el-form-item label="内容" class="mb-0">
							<el-input size="small" v-model="from.content" placeholder="搜索内容"></el-input>
						</el-form-item>

						
						
						<el-form-item label="發送時間" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							  range-separator="至" start-placeholder="開始日期" end-placeholder="結束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜尋 </el-button>
							<el-button size="small" @click="clearSearch">清空篩選條件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange">
				<el-table-column align="center" width="130" prop="email_no" label="編號">
				</el-table-column>

				<el-table-column align="center" width="200" prop="name" label="類型">
					<template slot-scope="scope">
						<span v-if="scope.row.type == 1" class="">
							普通郵件
						</span>
						<span class="text-warning" v-if="scope.row.type==2">
							題目反饋 - <span style="cursor: pointer;" class="text-primary"  @click="openTopicModel(scope.row.topic_no)">{{ scope.row.topic_no }}</span>
						</span>
					</template>
				</el-table-column>

				
				<el-table-column align="center" width="100" prop="name" label="類型">
					<template slot-scope="scope">
						<span  v-if="scope.row.out_type == 3" class="text-warning">
							學校
						</span>
						<span  v-if="scope.row.out_type == 4"  class="text-success">
							學生
						</span>
					</template>
				</el-table-column>



				<el-table-column align="center" prop="name" width="300" label="發送人">
					<template slot-scope="scope">
						<span>
							<el-tag v-if="scope.row.out_type == 3"  type="warning">{{scope.row.school_data.name}}</el-tag>
							<el-tag v-if="scope.row.out_type == 4" type="success">{{scope.row.user_data.name}}</el-tag>
						</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" prop="title" label="郵件標題">
								<template slot-scope="scope">
									<div v-if="scope.row.title.length > 20">
										{{ scope.row.title.substring(0, 20) }}... 
										<el-button type="text" @click="showFullTitle(scope.row.title)">點擊查看</el-button>
									</div>
									<div v-else>
										{{ scope.row.title }}
									</div>
								</template>
				</el-table-column>
				
				<el-table-column align="center" width="100" prop="content" label="郵件內容">
						<template slot-scope="scope">
							<div slot="reference" style="cursor: pointer;" class="name-wrapper" @click="openDialog(scope,1)">
								<el-tag size="medium">查看</el-tag>
							</div>
						</template>
				</el-table-column>

				<el-table-column align="center" width="100" prop="reply_content" label="回覆郵件">
						<template slot-scope="scope">
								<div v-if="scope.row.is_reply" slot="reference" style="cursor: pointer;" class="name-wrapper" @click="openDialog(scope,2)">
									<el-tag size="medium">查看</el-tag>
								</div>
								<div v-else slot="reference">
									未回覆
								</div>
						
						</template>
				</el-table-column>

				<el-table-column align="center"  prop="check_status"  width="80" label="是否已讀">
					<template slot-scope="v">
						<span style="color: red;" v-if="v.row.check_status==0 ">未讀</span>
						<span class="text-success" v-if="v.row.check_status==1 ">已讀</span>
					</template>
				</el-table-column>

				<el-table-column align="center" prop="create_time" width="160" label="發送時間">
				</el-table-column>

				<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="80" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							<el-button @click="reply(scope)" :disabled="scope.row.is_reply == 1" v-auth="'delRule'" size="mini" plain type="warning">回覆</el-button>
						</el-button-group>
					</template>
				</el-table-column>
				
			</el-table>
		</div>

		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"  
			title="回覆消息" 
			:visible.sync="createModel" 
			top="5vh" 
			:width="layout.is_phone ? '90%' : '80%'" 
			class="custom-dialog"
			>

			<el-form :rules="rulesTopic" ref="formEdit" :model="form" :label-width="layout.is_phone ? '80px' : '100px'" :label-position="layout.is_phone ? 'top' : 'left'">
			<template> 
						<el-descriptions v-if="form.out_type == 4" class="margin-top" title="學生信息" :column="3" style="margin-bottom: 30px;" border>
						<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								學生編號
							</template>
							{{ form.user_no }}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								學生姓名
							</template>
							{{ form.user_name }}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								學生英文名
							</template>
							{{ form.name_en }}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								聯絡電話
							</template>
							{{ form.phone }}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-message"></i>
								聯絡郵箱
							</template>
							{{ form.email }}
							</el-descriptions-item>
						
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-collection"></i>
								年級
							</template>
							{{form.g_name}}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-school"></i>
								就讀學校
							</template>
							{{form.school}}
							</el-descriptions-item>

						</el-descriptions>

						<el-descriptions v-if="form.out_type == 3" class="margin-top" title="學校信息" :column="3" style="margin-bottom: 30px;" border>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								名稱
							</template>
							{{ form.school_name }}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								英文
							</template>
							{{ form.school_name_en }}
							</el-descriptions-item>
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-user"></i>
								校長
							</template>
							{{ form.rector }}
							</el-descriptions-item>
							
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-mobile-phone"></i>
								電話
							</template>
							{{ form.school_phone }}
							</el-descriptions-item>
							
							<el-descriptions-item>
							<template slot="label">
								<i class="el-icon-message"></i>
								地址
							</template>
							{{ form.local }}
							</el-descriptions-item>
						</el-descriptions>


					<el-descriptions class="margin-top" title="郵件信息" :column="3" style="margin: 20px 0;">
						<el-descriptions-item label="编號"> {{ form.email_no }}</el-descriptions-item>
						<el-descriptions-item label="發送人">{{ form.in_type == 4 ? form.user_name : form.school_name }}</el-descriptions-item>
						<el-descriptions-item label="發送時間">
							{{ form.create_time }}
						</el-descriptions-item>
						
						<el-descriptions-item label="標題" :contentStyle="{'width': '80%'}">
							<!-- 限制高度並添加滾動條 -->
							
							{{ form.title }}
							
						</el-descriptions-item>
						<el-descriptions-item label="郵件内容"  :contentStyle="{'width': '90%'}">
							<!-- 限制高度並添加滾動條 -->
							<div class="email-content">
							{{ form.content }}
							</div>
						</el-descriptions-item>
					</el-descriptions>
			</template>
				<!-- 顶部信息展示区 -->
			

				<!-- 回复標題輸入 -->
				<el-form-item label="回覆標題" prop="reply_title">
				<el-input 
					type="text" 
					v-model="form.reply_title"
					maxlength="50"
					show-word-limit
					placeholder="回覆標題"
					clearable 
					size="small" 
					class="form-input"
				/>
				</el-form-item>

				<!-- 回复内容輸入 -->
				<el-form-item label="回覆内容" prop="reply_content">
				<el-input 
					type="textarea" 
					:rows="3" 
					v-model="form.reply_content"
					show-word-limit
					placeholder="回覆内容"
					clearable 
					size="small" 
					class="form-input"
				/>
				</el-form-item>
			</el-form>

			<!-- 底部按钮 -->
			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取消</el-button>
				<el-button type="primary" :loading="submitLoading" @click="submit">發送</el-button>
			</div>
		</el-dialog>

		<el-dialog :close-on-click-modal="false" title="修改題目" :visible.sync="createTopicModel" 
		top="5vh" :width="layout.is_phone?'90%':'60%'" @opened="scrollToTop">
		<div  ref="dialogContent" style="max-height: 65vh; overflow: auto;">
			<!-- 表單内容 -->
			<el-form :rules="rules" ref="dialogContent" :model="formTopic" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
			
				<el-form-item  label="題目图片" prop="icon" >
					<el-upload
					name="file"
					  class="avatar-uploader"
					  action="/admin/image/uploadNew"
					  :headers="{token:$store.state.user.token}"
					  :data="{type:'1',cms_type:'2'}"
					  :show-file-list="false"
					  :on-success="handleAvatarSuccess"
					  :before-upload="beforeAvatarUpload">
					  <img v-if="formTopic.icon" :src="formTopic.icon" class="avatar">
					  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>

				<el-form-item  label="題目類型"  prop="topic_type" >
					<span v-if="formTopic.topic_type == 1">選擇題</span>
					<span v-if="formTopic.topic_type == 2">填空題</span>
						
				</el-form-item>								
				
				<el-form-item label="年級"  prop="grade_id">
					<el-select  v-model="formTopic.grade_id">
						<el-option
						v-for="item in grade_list"
						:key="item.id"
						:label="item.name"
						:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="學科類型"   prop="subject_id">
					<el-select @change="changeType" v-model="formTopic.subject_id">
						<el-option
						v-for="item in subject_list"
						:key="item.id"
						:label="item.name"
						:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="題目標籤"   prop="label_id">
					<el-select v-model="formTopic.label_id">
						<el-option
						v-for="item in label_list"
						:key="item.id"
						:label="item.name"
						:value="item.id">
						</el-option>
						<el-option v-if="label_list.length === 0" disabled value="">暂无可选標籤</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="難度" prop="difficulty">
					
						<el-rate
							style="line-height: 49px;"
							v-model="formTopic.difficulty"
							:colors="colors">
						</el-rate>
				
				</el-form-item>

				<el-form-item label="題目" prop="title">
					<el-input type="textarea" :rows="8" v-model="formTopic.title" 
					placeholder="題目" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<div v-if="formTopic.topic_type == 1">
					<el-form-item label="A" prop="option_a">
						<el-input type="text" v-model="formTopic.option_a" clearable size="small" style="width: 85%; margin-right: 10px;"></el-input>
						<!-- 添加單选框 -->
						<el-radio v-model="formTopic.answer_o" label="a">正確答案</el-radio>
					</el-form-item>

					<el-form-item label="B" prop="option_b">
						<el-input type="text" v-model="formTopic.option_b" clearable size="small" style="width: 85%; margin-right: 10px;"></el-input>
						<!-- 添加單选框 -->
						<el-radio v-model="formTopic.answer_o" label="b">正確答案</el-radio>
					</el-form-item>

					<el-form-item label="C" prop="option_c">
						<el-input type="text" v-model="formTopic.option_c" clearable size="small" style="width: 85%; margin-right: 10px;"></el-input>
						<!-- 添加單选框 -->
						<el-radio v-model="formTopic.answer_o" label="c">正確答案</el-radio>
					</el-form-item>

					<el-form-item label="D" prop="option_d">
						<el-input type="text" v-model="formTopic.option_d" clearable size="small" style="width: 85%; margin-right: 10px;"></el-input>
						<!-- 添加單选框 -->
						<el-radio v-model="formTopic.answer_o" label="d">正確答案</el-radio>
					</el-form-item>

				</div>
				<div v-else>
					<el-form-item>
						<el-button type="primary" @click="addAnswer">新增答案</el-button>
					</el-form-item>

					<el-form-item label="答案" prop="answer">
						<div v-for="(answer, index) in formTopic.answer" :key="index" style="display: flex; align-items: center;">
							<el-input
							type="text"
							v-model="formTopic.answer[index]"
							placeholder="輸入答案"
							clearable
							size="small"
							style="width: 85%; margin-right: 10px;">
							</el-input>
							<el-button
							type="danger"
							icon="el-icon-delete"
							size="small"
							:disabled="formTopic.answer.length === 1"
							@click="removeAnswer(index)">
							刪除
							</el-button>
						</div>
					</el-form-item>
				</div>
				
				<el-form-item label="默認分數" prop="score">
					<el-input type="text" v-model="formTopic.score" 
					placeholder="題目默認分數" 
					clearable size="small" style="width: 85%;">
					
					</el-input>
				</el-form-item>
				
					
				<el-form-item label="解釋" prop="explanation">
					<el-input type="textarea" :rows="4" v-model="formTopic.explanation" class="content_huan"
					placeholder="解釋" 
					clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
			</el-form>
		</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createTopicModel = false">取 消</el-button>
				<el-button type="primary" @click="submitTopic">確 定</el-button>
			</div>
		</el-dialog>


		
		<el-dialog :close-on-click-modal="false"  
			:visible.sync="dialogVisible" 
			:width="layout.is_phone ? '90%' : '70%'" 
			title="郵箱信息" 
			@close="closeDialog"
			>
			<!-- 郵件信息头部 -->
			<div v-if="dialogType == 1" class="dialog-header">
				<div class="email-info">
				<p><strong>標題：</strong> {{ emailTitle }}</p>
				<p><strong v-if="is_reply == 1">發送人：</strong><strong v-if="is_reply == 2">回覆人：</strong> {{ senderName }}</p>
				<p><strong>發送時間：</strong> {{ sendTime }}</p>
				</div>
			</div>
			
			
			<!-- 郵件内容 -->
			<div v-html="dialogContent" class="dialog-content"></div>
			
			<!-- 弹框底部 -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeDialog">關 閉</el-button>
			</span>
		</el-dialog>


		<el-dialog :close-on-click-modal="false"  :visible.sync="dialogTitleVisible" title="標題">
			<p>{{ fullTitle }}</p>
		</el-dialog>
		

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				emailTitle: '' ,         // 
				senderName: '' ,         // 
				sendTime: '' ,         // 
				dialogType:1,
				
				is_reply:1,
				submitLoading: false,
				dialogTitleVisible: false,
					fullTitle: '',
				rules: {
					
					reply_content: [{
							required: true,
							message: "回覆內容不能為空",
							trigger: 'blur',
						},
					],
					reply_title: [{
							required: true,
							message: "回覆標題不能為空",
							trigger: 'blur',
						},
					],
				
					
				},
				createModel: false,
				editIndex: -1,
				//搜索數据
				from: {
					name: '',
					email_no: '',
					in_name: '',
					content:'',
					all_type:-1,
					type: -1,
					check_status:-1,
					time: [],
				},

				createTopicModel: false,
				formTopic: {
					title:'',
						answer:[''],
						img:'',
						score:10,
						topic_type:1,
						grade_id:null,
						subject_id:null,
						label_id:null,
						icon:'',
						option_a:'',
						option_b:'',
						option_c:'',
						option_d:'',
						explanation:'',
						answer_o: 'a',
						difficulty:1,
				},
				colors: ['#99A9BF', '#F7BA2A', '#FF9900'],  // 等同于 { 2: '#99A9BF', 4: { value: '#F7BA2A', excluded: true }, 5: '#FF9900' }
				rulesTopic: {
					title: [{
							required: true,
							validator: (rule, value, callback) => {
								if (!value) {
									callback(new Error('請輸入題目'));
								} else {
									let chineseCount = (value.match(/[\u4e00-\u9fa5]/g) || []).length;  // 统计中文字符
									let englishCount = value.length - chineseCount;  // 统计英文字符

									if (chineseCount > 200) {
										callback(new Error('內容不能超過200个中文字符'));
									} else if (englishCount > 400) {
										callback(new Error('內容不能超過400个英文字符'));
									} else {
										callback();  // 验证通过
									}
								}
							},
							trigger: 'blur',
						},
					],
					answer: [
						{ 
							required: true, 
							validator: (rule, value, callback) => {
								// 检查 answer 數組中的每一个元素是否为空
								if (value.some(answer => !answer)) {
									callback(new Error("答案不能為空"));
								} else {
									callback();
								}
							},
							trigger: 'blur'
						}
					],
					option_a: [{
							required: true,
							message: "选项A不能為空",
							trigger: 'blur',
						},
					],
					option_b: [{
							required: true,
							message: "选项B不能為空",
							trigger: 'blur',
						},
					],
					option_c: [{
							required: true,
							message: "选项C不能為空",
							trigger: 'blur',
						},
					],
					option_d: [{
							required: true,
							message: "选项D不能為空",
							trigger: 'blur',
						},
					],
					label_id: [{
							required: true,
							message: "請選擇標籤",
							trigger: 'blur',
						},
					],
					difficulty: [{
							required: true,
							message: "請選擇題目難度",
							trigger: 'blur',
						},
					],
				},
				labels: ['A', 'B', 'C', 'D'], // 可根据需要增加更多的標籤
				label_list: [],
				all_label_list: [],
				subject_list: [],
				grade_list: [],


				model_title: 'Notice',
				auth_val: 'Notice',
				preUrl: "data/emailReplyList", //列表地址
				addUrl: "data/addEmail", //回覆郵件
				delAllUrl: "data/delEmailReplyAll", //批量删除地址
				delUrl: "data/delEmailReply", //删除單条地址
				tableData: [],
				form: {
					id: 0,
					title:'',
					content:"",
					appoint_id:0,
					all_type:0,
				},
				prop: 'a.create_time',
				sort: 'descending',
				rule_list: [],
				total_list: [],
				check_img_list: [],
				fileList: [],

				school_list: [],
				inst_list: [],
				user_list: [],
				
				dialogVisible: false,      // 控制對話框顯示
				dialogContent: '' ,         // 存储當前对话框的内容

				emailTitle: '' ,        
			}
		},
		watch: {
			refreshTrigger(newVal) {
				console.log('刷新触发，當前值:', newVal);
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
			activeName(e) {
				console.log(e);
			}
		},
		computed: {
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['topic_subject_label','grade_list']);
		},
		methods: {
			scrollToTop() {
				// 獲取滾動容器並設置滾動條位置
				const content = this.$refs.dialogContent;
				if (content) {
					content.scrollTop = 0; // 將滾動條設置到頂端
				}
			},
			openTopicModel(topic_no){
				this.layout.loading = true;
				this.axios.post('/admin/data/getTopicNoInfo', {
					topic_no: topic_no,
				}, {
					token: true,
				}).then(res => {
					let all = res.data.data
					let list = all.list
					this.formTopic = list
					this.createTopicModel = true
					this.layout.loading = false;
					this.label_list = this.all_label_list[this.formTopic.subject_id] || [];
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})

				
			},
			openDialog(e,type) {
				let row = e.row
				if(type == 2){
					this.dialogContent = row.reply_content; // 设置要顯示的 HTML 内容
					this.emailTitle = row.reply_title; // 设置要顯示的 HTML 内容
					this.senderName = row.reply_name; // 设置要顯示的 HTML 内容
					this.sendTime = row.reply_time; // 设置要顯示的 HTML 内容
				}else{
					this.dialogContent = row.content; // 设置要顯示的 HTML 内容
					this.emailTitle = row.title; // 设置要顯示的 HTML 内容
					this.senderName = row.sender_name; // 设置要顯示的 HTML 内容
					this.sendTime = row.create_time; // 设置要顯示的 HTML 内容
					this.emailRead(row)
				}
				
				this.dialogType = 1; // 设置要顯示的 HTML 内容
				this.is_reply = type; // 设置要顯示的 HTML 内容
				this.replyData = e; // 设置要顯示的 HTML 内容
				
				this.dialogVisible = true;    // 顯示对话框
			},
			emailRead(e){
				if(e.check_status == 0){
					this.axios.post('/admin/data/emailRead', {
						type: 1,
						id:e.id,
					}, {
						token: true,
					}).then(res => {
						this.getList()
						this.layout.getPageNum();
					})
				}
			},
			closeDialog() {
				this.dialogVisible = false;   // 關閉对话框
				this.dialogContent = '';      // 清空内容
				this.dialogTitle = '';      // 清空内容
			},
			
			changeType(){
				// 设置label_list并處理可能的空值
				this.label_list = this.all_label_list[this.formTopic.subject_id] || [];
				if (this.label_list.length > 0) {
					// 如果label_list不为空，则设置默認选中项为第一个元素的ID
					if(this.editIndex == -1){
						this.formTopic.label_id = this.label_list[0].id;
					}
				} else {
					// 如果label_list为空，可以设置label_id为null或其他逻辑處理
					this.formTopic.label_id = null;
				}
			},
			 // 顯示完整標題内容
			 showFullTitle(title) {
				this.fullTitle = title;
				this.dialogTitleVisible = true;
			},
			reply(e){
				// 初始化表單數據
				this.form = {
					id: e.row.id,
					in_id: e.row.out_id,
					out_type: e.row.out_type,
					reply_type: 2,
					is_reply:2,

					school_id: e.row.school_data.id,
					school_name: e.row.school_data.name,
					school_name_en: e.row.school_data.name_en,
					school_phone: e.row.school_data.phone,
					local: e.row.school_data.local,
					rector: e.row.school_data.rector,

					user_name: e.row.user_data.name,
					user_no: e.row.user_data.user_no,
					name_en: e.row.user_data.name_en,
					phone: e.row.user_data.phone,
					email: e.row.user_data.email,
					school: e.row.user_data.school_name,
					g_name: e.row.user_data.grade_name,

					title: e.row.title,
					email_no: e.row.email_no,
					create_time: e.row.create_time,
					content: e.row.content,
					
					reply_content: '',
					reply_title: 'RE:' + e.row.title,
				};
				this.editIndex = e.row.id;
				this.createModel = true;
			},
			// 添加一个新的答案輸入框
			addAnswer() {
				this.formTopic.answer.push(''); // 每次點擊新增按钮，往數組中添加一个空字符串
			},
			// 刪除对应的答案輸入框
			removeAnswer(index) {
				this.formTopic.answer.splice(index, 1); // 刪除指定索引的答案
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					this.subject_list = list.subject
					this.grade_list = list.grade
					this.all_label_list = list.label
					if (this.grade_list.length > 0) {
						// 设置默認选中项为subject_list中的第一个元素
						this.formTopic.grade_id = this.grade_list[0].id;
					}
					if (this.subject_list.length > 0) {
						// 设置默認选中项为subject_list中的第一个元素
						this.formTopic.subject_id = this.subject_list[0].id
						this.label_list = list.label[this.subject_list[0].id]
						if (this.label_list.length > 0) {
							// 设置默認选中项为subject_list中的第一个元素
							this.formTopic.label_id = this.label_list[0].id;
						}
					}
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			submitTopic(){
				this.layout.loading = true;
				this.axios.post('/admin/data/addTopic', this.formTopic, {
					token: true,
				}).then(res => {
					let all = res.data;
					if (all.code == 1) {
							this.$message({
								message: all.msg,
								type: 'success'
							}); // 控制是否顯示成功提示
						this.createTopicModel = false;
					}else{
						this.$message.error('操作失敗');
					}
					
					this.layout.loading = false;

				}).catch(err => {
					this.$message.error('操作失敗');
					// 失敗
					this.layout.loading = false;
				})
			},
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				this.$refs.formEdit.validate(res => {
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
			handleAvatarSuccess(res, file) {
				// this.formTopic.icon = URL.createObjectURL(file.raw);
				this.$set(this.formTopic, 'icon', URL.createObjectURL(file.raw));
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.formTopic.headUrl = res.encryption.data.list.url
				}
			},

			beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isJPG) {
				  this.$message.error('文件格式错误!');
				}
				if (!isLt2M) {
				  this.$message.error('上傳图片大小不能超過 2MB!');
				}
				return isJPG && isLt2M;
			},

			  
			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					email_no: '',
					in_name: '',
					content:'',
					type:-1,
					all_type:-1,
					check_status:-1,
					time: [],
				}

				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
</style>
